import styled from 'styled-components/native';

export default styled.View<{ m?: string }>`
  padding: 0 15px;
  width: 100%;
  margin: ${({ m }) => m || 0};
`;
